// UserRanksColumns.js
import { createColumnHelper } from "@tanstack/react-table";
import { formatDate } from "../../utils/formatDate";
import { StatusChip } from "../common/StatusChip";

export const getUserRanksColumns = (setSelectedRank, setModalOpen) => {
  const columnHelper = createColumnHelper();

  return [
    columnHelper.accessor("period", {
      header: "Periodo",
      cell: (info) => {
        const period = info.getValue();
        if (!period) return "—";
        const start = period.start.split('T')[0].split('-').reverse().join('/');
        const end = period.end.split('T')[0].split('-').reverse().join('/');
        return `${start} - ${end}`;
      },
    }),
    columnHelper.accessor("calculation_date", {
      header: "Fecha cálculo",
      cell: (info) =>
        info.getValue()
          ? formatDate(info.getValue())
          : "—",
    }),
    columnHelper.accessor("status", {
      header: "Estado",
      cell: (info) => {
        const status = info.getValue();
        const tone =
          status === "COMPLETED"
            ? "success"
            : status === "PENDING"
            ? "warning"
            : "neutral";
        return <StatusChip tone={tone}>{status}</StatusChip>;
      },
    }),
    columnHelper.display({
      id: "totalPoints",
      header: "Total Puntos",
      cell: (props) => {
        const users = props.row.original.users || [];
        const totalPoints = users.reduce(
          (sum, user) => sum + (user.total_points || 0),
          0
        );
        return (
          <strong className="text-primary">
            {totalPoints.toLocaleString()} pts
          </strong>
        );
      },
    }),
    columnHelper.display({
      id: "usersCount",
      header: "Usuarios",
      cell: (props) => props.row.original.users?.length ?? 0,
    }),
    columnHelper.display({
      id: "actions",
      header: "Acciones",
      cell: (props) => (
        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="ui-icon-btn ui-icon-btn--accent"
            onClick={() => {
              setSelectedRank(props.row.original);
              setModalOpen(true);
            }}
            title="Ver detalle"
          >
            <i className="ri-eye-line" />
          </button>
        </div>
      ),
    }),
  ];
};
